<template>

    <div class="c-page u-relative">
      <section data-color="clear" class="u-relative u-fit-w u-bg--brand-dark u-overflow-h js-header-panel">
        <div class="c-page__header o-wrapper--panel" :style="'transform:translateX(' + headerPageSize[2] + 'px) translateY('+headerPageSize[3]+'px) scale('+headerPageSize[4]+')'" >
                      <img :src="globalContent.nav.links[5].image.src" class="u-absolute u-pos-tl" :style="'width:' + headerPageSize[0] + 'px; height:'+headerPageSize[1]+'px' ">
          </div>
          <div class="o-wrapper--valign u-viewport-fit-h-half u-fit-w">
            <div class="u-relative u-inline-block u-valign-middle u-marg-t-vh1of10 u-fit-w u-pad-l-w3of12 u-pad-l-w2of12@xl u-pad-r-w4of12 u-pad-r-w3of12@xl u-pad-x-w1of12@sm">
                  <div class="introduction__inner">
                  <div class="introduction__titles">
                       <div class="introduction__titlesInner">
                            <div class="introduction__subtitle">
                              <h1 class="t-h3 t-text--roman t-text-lh--md u-color--black">

                                <div class="u-fit-w">
                                  <div class="u-marg-l-sm u-marg-r-sm   privinvest-box-page   t-text--md--bold@md u-relative">
                                              <span class="c-home__section__upcomingprogram_title   c-inspire-title--color">
                                                  <svg viewBox="0 0 300 35" >
                                                      <text x="0" y="25" class="u-color--black--fill">{{contactustriger.title}}</text>
                                                    </svg>
                                                  </span>
                                              <!--<span  class="c-line c-line--x u-absolute u-pos-bl u-bg--white u-fit-w"></span>-->
                                            </div>
                                 </div>
                               </h1>
                           </div>
                      </div>
                  </div>
                </div>

                </div>

          </div>

      </section>

      <section  :data-color="clear"  class="u-relative u-overflow-h u-fit-w  u-pad-x-w1of12  u-pad-x-w1of12@sm   js-header-panel" :class="[contactustriger.blocks[0].bgColorClass]" >
          <div class="privinvest-box-page u-relative u-flex u-pad-yb0-lg@sm u-flex-fd--column@sm u-pad-t-xl u-pad-b-lg u-zindex--2">

              <div class="u-marg-b-xxl u-marg-b-lg@sm u-w5of8 u-w1of2@md  u-pad-l-0@lg u-fit-w@sm" :class="{'u-pad-l-w1of8':contactustriger.blocks[0].padLeft==='1'}">
                  <div>
                    <app-scroll-object :offset=".05" :isParallax="!1" inline-template :content="contactustriger.blocks[0]">
                          <h3 class="t-h3 t-text--roman u-relative u-marg-r-lg   u-marg-r-0@sm" :class="{'u-color--brand-dark':content.color==='dark','u-color--white':content.color==='white'}">
                              <app-words  :isActive="isActive" :delay="0" :content="content.title"></app-words>
                            </h3>
                      </app-scroll-object>
                  </div>
                  <div :key="indexin" v-for="(itemin, indexin)  in contactustriger.blocks[0].content">
                      <h6 class=" t-text--ultra u-pad-t-lg" v-if="'title'===itemin.type.value" :class="{'t-text--md--bold':itemin.bold==='true','u-color--brand-dark':itemin.color==='dark','u-color--white':itemin.color==='white','u-color--gray':itemin.color==='gray'}">
                          <app-scroll-object   :offset=".05"  :isParallax="!1" inline-template  :content="itemin" >
                               <app-words  :isActive="isActive" :delay="0" :content="content.content"></app-words>
                           </app-scroll-object >
                        </h6>
                      <div class="u-marg-t-md t-text--ultra" v-if=" 'default'===itemin.type.value" :class="{'u-marg-t-md':indexin>0,'u-color--gray':itemin.color==='dark','u-color--white':itemin.color==='white'}" v-html="itemin.content"> </div>
                    </div>
              </div>

              <div class="u-marg-b-xxl u-marg-b-lg@sm u-w5of8 u-w1of2@md  u-pad-l-0@lg u-fit-w@sm" :class="{'u-pad-l-w1of8':contactustriger.blocks[1].padLeft==='1'}">
                  <div>
                    <app-scroll-object :offset=".05" :isParallax="!1" inline-template :content="contactustriger.blocks[1]">
                          <h3 class="t-h3 t-text--roman u-relative u-marg-r-lg   u-marg-r-0@sm" :class="{'u-color--brand-dark':content.color==='dark','u-color--white':content.color==='white'}">
                              <app-words  :isActive="isActive" :delay="0" :content="content.title"></app-words>
                            </h3>
                      </app-scroll-object>
                  </div>
                  <div :key="indexin" v-for="(itemin, indexin)  in contactustriger.blocks[1].content">
                      <h6 class=" t-text--md u-pad-t-lg" v-if="'title'===itemin.type.value" :class="{'t-text--ultra--bold':itemin.bold==='true','u-color--brand-dark':itemin.color==='dark','u-color--white':itemin.color==='white','u-color--gray':itemin.color==='gray'}">
                          <app-scroll-object   :offset=".05"  :isParallax="!1" inline-template  :content="itemin" >
                               <app-words  :isActive="isActive" :delay="0" :content="content.content"></app-words>
                           </app-scroll-object >
                        </h6>
                      <div class="u-marg-t-md t-text--ultra" v-if=" 'default'===itemin.type.value" :class="{'u-marg-t-md':indexin>0,'u-color--gray':itemin.color==='dark','u-color--white':itemin.color==='white'}" v-html="itemin.content"> </div>
                    </div>
              </div>
              <div class="mapouter"><div class="gmap_canvas"><iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13211.72452259113!2d35.6533012!3d34.1225128!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151f5ca820f6ada5%3A0x81e96609f00cbea9!2sSalameh%20-%20Jbeil!5e0!3m2!1sen!2slb!4v1705463991892!5m2!1sen!2slb" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe></div></div>
          </div>
        
      </section>


     



       <app-footer :globalContent="globalContent" :adminContent="adminContent"></app-footer>


 </div>

</template>
<script>
import {format, compareAsc} from 'date-fns'
import AppFooter from  '../app-footer/index.vue'
import  AppSlicedText from '../app-sliced-text/index.vue'
import   CoreAjaxForm from     '../core-ajax-form/index.vue'

import {getAbsoluteBoundingRect}  from '../../utilities/getAbsoluteBoundingRect.js'
import AppScrollObject from '../app-scroll-object/index.vue'

export default
{
          components:{

                                    "app-sliced-text":AppSlicedText,
                                    "app-footer":AppFooter,
                                    'core-ajax-form':CoreAjaxForm,
                                    "app-scroll-object":AppScrollObject

                    },
                  props: {
                      adminContent: {
                          type: Object,
                          default: function() {}
                      },
                      globalContent: {
                          type: Object,
                          default: function() {}
                      },
                      headerPageSize: {
                          type: Array,
                          default: function() {}
                      }
                  },
                  data: function() {
                      return {
                          areTherePosts: !1,
                          areThereCategories: !1,
                          selectedOption:'',
                          CarModel:Object(),
                           popinContent: null,
                           popinTitle: null,
                            isPopinActive: !1,
                            isPopinActivePhotos: !1,
                            isButtonClicked:false,
                            isButtonVisible: !0,
                            isButtonActive: !1,
                            uiexplore:"Scroll to discover"
                      }
                  },
                  computed:
                  {
                    contactustriger: function()
                     {
                         return  this.adminContent.en.contactustriger
                     },

                        computedPostsCategories: function()
                        {
                          var t = [];

                              if (Object.keys(this.adminContent.en.repairandrefitpriv).length > 0)
                              {
                                  if (this.adminContent.en.repairandrefitpriv.categories)
                                  {
                                      this.areThereCategories = !0;
                                      var   n = this.adminContent.en.repairandrefitpriv.categories.length;
                                      for (var e = 0;e < n; e += 1)
                                      {
                                          var r =  this.adminContent.en.repairandrefitpriv.categories[e];
                                           t.push(r)
                                      }

                                  }
                                  else
                                  {
                                   this.areThereCategories = !1,
                                   t.push({
                                      title: "Error - Page not found",
                                      first_paragraph_shorted: "Incorrect page number. <br /> Please click on one of the page numbers below.",
                                      dateFormated: {
                                          day: 404,
                                          month: "",
                                          year: ""
                                      }
                                  })
                                }
                              }


                          return t
                        }
                    
                  },
                  beforeCreate: function()
                  {
                      //this.$route.query.page || this.$router.push("/theelitecars/current-stock?page=1")
                  },
                  created: function()
                  {
                      
                      this.onResize = this.onResize.bind(this),
                     
                      this.eventHub.$on("close:popin", this.onClosePopin),
                      this.eventHub.$on("resize", this.onResize)
                  },
                  destroyed: function()
                  {
                      this.eventHub.$off("close:popin", this.onClosePopin),
                      this.eventHub.$off("resize", this.onResize)
                  },
                  mounted: function()
                  {
                    setTimeout(function() {this.isButtonVisible = !0}, 120),
                    setTimeout(function() {this.isButtonActive = !0}, 3e3),
                      this.eventHub.$emit("page:ready"),
                      this.onResize()
                  },

                  methods:
                  {

                      onResize: function() {},
                      onOpenPopin: function (t, e)
                      {
                          if(this.isButtonClicked)
                             return false;
                            // alert("popin main no");
                          var n = this;
                          this.popinIndex = 0,
                          this.popinContent =   t,
                          this.popinTitle =   t.title,
                          this.eventHub.$emit("disable:scroll"),
                            this.eventHub.$emit("open:popin"),
                          setTimeout(function ()
                          {
                              n.isPopinActive = !0,
                              n.$el.classList.add("is-popin-active"),
                              n.onTransition()
                          }, 50)
                      },
                      onOpenPopinPHOTOS: function (t, e)
                      {
                          this.isButtonClicked=true;
                          //alert("popin photo");
                          var n = this;
                          this.popinIndex = 0,
                          this.popinContent =   t,
                          this.popinTitle =   t.title,
                          this.eventHub.$emit("disable:scroll"),
                            this.eventHub.$emit("open:popin"),
                          //this.eventHub.$emit("open:popinphotos"),
                          setTimeout(function ()
                          {
                              n.isButtonClicked=false;
                              n.isPopinActivePhotos = !0,
                              //n.$el.classList.add("is-popin-active--photos"),
                              n.$el.classList.add("is-popin-active"),
                              n.onTransition()
                          }, 50)
                      },
                      onHoverPopin: function (t, e)
                      {

                             var n = this;

                              n.$el.querySelector('#'+t).classList.remove("is-start-switching--cars--back"),
                              n.$el.querySelector('#'+t).classList.add("is-start-switching--cars")

                      },
                      onHoverOutPopin: function (t, e)
                      {
                         var n = this;
                           n.$el.querySelector('#'+t).classList.remove("is-start-switching--cars"),
                          n.$el.querySelector('#'+t).classList.add("is-start-switching--cars--back")

                      },
                      onClosePopin: function ()
                      {
                          this.eventHub.$emit("enable:scroll"),

                          this.isPopinActive = !1,
                          this.isPopinActivePhotos = !1,
                          //this.isBoardActive = !1,
                          this.$el.classList.remove("is-popin-active"),
                          this.onTransition()

                      },
                      onTransition: function ()
                      {
                          var t = this;
                          this.$el.classList.add("is-switching"),
                          clearTimeout(this._timerTransition),
                          this._timerTransition = setTimeout(function () {
                              t.$el.classList.remove("is-switching")
                          }, 650)
                      }
                  }
    }

</script>
<style  scoped>
/*SVG ICON SYSTEM*/
.icon {
    display: inline-flex;
    align-self: center;
}

.icon svg, .icon img {
    height: 2rem;
    width: 2rem;
    fill: currentColor;
}

.icon.baseline svg, .icon img {
    top: .125em;
    position: relative;
}
.mapouter{position:relative;text-align:right;height:500px;width:100%;margin-bottom: 60px;}
.gmap_canvas {overflow:hidden;background:none!important;height:500px;width:100%;}
/*

h3 {
    margin:0 0 5px 0;
    padding:0;
    line-height:1;
    font-weight:normal;
  position:relative;
  color: #000;
}



h3 {
  font-size: 15px;
}*/
.containercarousel_Image .style-3 ins {
    font-weight: 200;
    text-decoration: none;
    padding: 0px;
    margin:0px;
    color: #d93746;
}
.containercarousel_Image .blockdownInfo {
    -webkit-transition: .5s ease;
    transition: .5s ease;
    opacity: 1;
    position: relative;
    top: 0;
    left: 0;
    -webkit-transform: translate(0, 0);
    transform: translate(0, 0);
    -ms-transform: translate(0, 0);
    text-align: left;
}
.containercarousel_Image {
    position: relative;
    padding: 0px;
}
.icontext
{
  position:relative;
  top:-10px;
  left: -8px

}
.t-btn span {
  cursor: pointer;
  display: inline-block;
  position: relative;
  transition: 0.5s;
}
.t-btn:hover {
  opacity: 0.5;
}
/*
.t-btn span:after {
  content: '\00bb';
  position: absolute;
  opacity: 0;
  top: 0;
  right: -20px;
  transition: 0.5s;
}

.t-btn:hover span {
  padding-right: 25px;
}

.t-btn:hover span:after {
  opacity: 1;
  right: 0;
}*/
@media screen and (max-width: 550px)
{
  .t-btn span:after {
    content: '';
    position: absolute;
    opacity: 0;
    top: 0;
    right: 0;
    transition: 0.5s;
  }
  /*.t-btn:hover span {
    padding-right: 0px;
  }
  .t-btn:hover span:after {
    opacity: 0;
    right: 0;
  }*/
  .icon svg, .icon img {
      height: 1.5rem;
      width: 1.5rem;
      fill: currentColor;
  }
  .icontext
  {
    position:relative;
    top:-5px;
    left: -5px

  }
  .text-center--sm
  {
     text-align: center;
  }
}
</style>
